<template>
  <div v-if="!isLoading">
    <section class="mb-8 flex items-center justify-between">
      <div class="flex items-center gap-x-8">
        <h1>{{ $t("organization") }}</h1>
        <BaseSearch @on-searching="setFilterText" />
      </div>
      <BaseButton v-if="user.role_id == 2" @click="handleNewOrganization">{{ $t("addNew") }}</BaseButton>
    </section>
    <BaseDataList :tot-data="filteredData.length" :is-searching="!!filterText">
      <GridRow class="gap-6">
        <GridCol :span-md="6" v-for="organization in filteredData">
          <OrganizationCard v-bind="organization" :key="organization.id" :organization="organization" />
        </GridCol>
      </GridRow>
    </BaseDataList>
  </div>
  <BaseLoader v-else/>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import useModalStore from "@/stores/modal";
import useAuthStore from "@/stores/auth";
import useOrganizationStore from "@/stores/organization";
import OrganizationCard from "@/components/organizations/OrganizationCard.vue";
import OrganizationForm from "@/components/organizations/OrganizationForm.vue";
import useFilterData from "@/composables/useFilterData";

const { fetchOrganizationList } = useOrganizationStore();
const { user } = storeToRefs(useAuthStore());

const modal = useModalStore();
const { t } = useI18n();

const isLoading = ref()

/**
 * Handle new organization event.
 */
function handleNewOrganization() {
  modal.openModal({
    title: t("newOrganization"),
    component: OrganizationForm,
    props: {},
    customClass: "w-[40rem] max-w-[40rem] "
  });
}

/**
 * Filter organization list.
 */
const { organizationList } = storeToRefs(useOrganizationStore());
const { filterText, setFilterText, filteredData } = useFilterData(
  organizationList,
  ["name"],
);

onMounted(async () => {
  try{
    isLoading.value = true
    await fetchOrganizationList();
  } catch (e) {
    console.error(e)
  } finally {
    isLoading.value = false
  }
})
</script>
